import { Alpine as AlpineType } from 'alpinejs';
export default (Alpine: AlpineType) => {
  Alpine.data('productVariants', () => ({
    isOpen: false,
    currentSelectedHTML: '',

    init(defaultTitle: string = '', defaultServings: number = 0, defaultBestSeller: boolean = false) {
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleEsc = this.handleEsc.bind(this);

      if (!Alpine._productVariantsInstances) {
        Alpine._productVariantsInstances = [];
      }
      Alpine._productVariantsInstances.push(this);

      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleEsc);

      this.updateSelectedHTML({
        title: defaultTitle,
        servings: defaultServings,
        isBestSeller: defaultBestSeller
      });
    },

    updateSelectedHTML({ title, servings = 0, isBestSeller = false }: { title: string, servings?: number, isBestSeller?: boolean, qty?: number }) {

      this.currentSelectedHTML = `
        <span class="inline-block text-base md:text-lg md:leading-8 capitalize font-semibold">${title}</span>
        ${servings > 0 ? `<span class="text-xs uppercase font-medium font-heading mt-[4px] md:mt-0 md:mb-[6px] text-center">${servings} Servings</span>` : ''}
        ${isBestSeller ? `<span class="product-view__best-seller-badge top-0 -translate-y-1/2 rounded-2xl bg-tertiary font-heading font-medium text-white transition-colors px-1.5 md:px-[12px] py-0 text-[10px]">Most Popular</span>` : ''}
      `;
      this.currentSelectedButtonHTML =`<div class="nss-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
              <path d="M11 1L6 5L1 0.999999" stroke="#59432D" stroke-width="1.5" stroke-linecap="round"></path>
            </svg>
          </div>
          <span class="inline-block text-base md:text-lg md:leading-8 capitalize font-semibold"
                x-text="currentVariantTitle">${title}</span>
        ${servings > 0 ? `<span class="text-xs uppercase font-medium font-heading mt-[4px] md:mt-0 md:mb-[6px] text-center">${servings} Servings</span>` : ''}
        ${isBestSeller ? `<span class="product-view__best-seller-badge top-0 -translate-y-1/2 rounded-2xl bg-tertiary font-heading font-medium text-white transition-colors px-1.5 md:px-[12px] py-0 text-[10px]">Most Popular</span>` : ''}
     `;

    },


    toggle(e: Event) {
      e.stopPropagation();
      Alpine._productVariantsInstances.forEach(instance => {
        if (instance !== this) instance.isOpen = false;
      });

      this.isOpen = !this.isOpen;
    },

    close() {
      this.isOpen = false;
    },

    handleClickOutside(e: Event) {
      if (!this.$el.contains(e.target as Node)) {
        this.close();
      }
    },

    handleEsc(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        this.close();
      }
    },

    destroy() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEsc);

      Alpine._productVariantsInstances = Alpine._productVariantsInstances.filter(inst => inst !== this);
    }
  }));
};
